// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3NMZ4","unreadBadge":"styles_unreadBadge__1zaDU","modalContent":"styles_modalContent__9o0us","modal":"styles_modal__29Uo2"};